export default __webpack_public_path__ + "beta-maps-example-point-annotation-960-e9c9f79270fd4815ffb52d55720045cf.webp";